export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7046.0932f573.jpg";